import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class SamlService {

  env = environment;

  constructor(private readonly http: HttpClient) { }

  getToken(data) {
    return this.http.post(this.env.webApiUrl + 'api/Saml/GetToken', data);
  }

}
